import lang from '@/lang'
import { ModuleTypes } from '@/modules/base/util/constants'
// as files (?url), shown with <img>: the icons carry a gradient with ids, which SVGO shortens when they are
// inlined - several inline icons on one page would then point at each other's ids
import MultiUserIcon from '@assets/images/icons/addons/addon-weitere-benutzer.svg?url'
import RecurringInvoicesIcon from '@assets/images/icons/addons/addon-abo-rechnungen.svg?url'
import LetterPaperIcon from '@assets/images/icons/addons/addon-mehrere-briefpapiere.svg?url'
import StorageIcon from '@assets/images/icons/addons/addon-dokumentenspeicher.svg?url'
import PublicApiIcon from '@assets/images/icons/addons/addon-api-anbindung.svg?url'

// DO-13587: the add-on icons of the new design - 44 px rounded squares with a gradient
const ADDON_ICONS: Record<string, string> = {
  [ModuleTypes.MULTI_USER]: MultiUserIcon,
  [ModuleTypes.RECURRING_INVOICES]: RecurringInvoicesIcon,
  [ModuleTypes.MULTI_LETTERPAPER]: LetterPaperIcon,
  [ModuleTypes.STORAGE_PACKAGE]: StorageIcon,
  [ModuleTypes.PUBLIC_API]: PublicApiIcon,
}

export const getAddonIcon = (name: string): string | undefined => ADDON_ICONS[name]

/**
 * Name of an add-on in the checkout (tile, "Deine Auswahl", success page), e.g. "Abo-Rechnungen" -
 * the title of the API is used for add-ons the design does not name.
 */
export const getAddonTitle = (name: string, title: string): string => lang.upgrade.wizard.addons.titles[name] || title
